
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.2 19.707a1 1 0 01-1.414 0l-4.243-4.243a1 1 0 010-1.414l4.243-4.242A1 1 0 019.2 11.222l-2.542 2.543H15.5a3 3 0 003-3V5.14a1 1 0 012 0v5.625a5 5 0 01-5 5H6.672L9.2 18.293a1 1 0 01.083 1.32z"}})])
          )
        }
      }
    